import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideAppInitializer,
  inject
} from '@angular/core'
import { provideRouter, RouteReuseStrategy } from '@angular/router'
import { BrowserModule } from '@angular/platform-browser'
import { IonicModule, IonicRouteStrategy } from '@ionic/angular'
import { ServiceWorkerModule } from '@angular/service-worker'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideIonicAngular } from '@ionic/angular/standalone'
import { provideCharts, withDefaultRegisterables } from 'ng2-charts'
import { GlobalErrorHandler } from './services/global-error-handler/global-error-handler.service'
import { WidgetErrorComponent } from './services/global-error-handler/widget-error/widget-error.component'
import { routes } from './app.routes'
import { RxdbService } from './services/rxdb/rxdb.service'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      BrowserModule,
      IonicModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
    ),
    provideAppInitializer(() => inject(RxdbService).initDB()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: WidgetErrorComponent },
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    provideRouter(routes)
  ]
}
